import { render, staticRenderFns } from "./CreateForum.vue?vue&type=template&id=00f7f062&scoped=true"
import script from "./CreateForum.vue?vue&type=script&lang=js"
export * from "./CreateForum.vue?vue&type=script&lang=js"
import style0 from "./CreateForum.vue?vue&type=style&index=0&id=00f7f062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f7f062",
  null
  
)

export default component.exports